import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';

export interface UnsavedChangesDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const UnsavedChangesDialog: React.FC<UnsavedChangesDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => (
  <Dialog open={open} onClose={onCancel} maxWidth="sm" fullWidth>
    <DialogTitle>
      <Box display="flex" alignItems="center" gap={1}>
        <WarningIcon color="warning" />
        <Typography variant="h6">Unsaved Changes</Typography>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Typography>
        You have unsaved changes. Are you sure you want to leave? Your changes will be lost.
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} variant="outlined">
        Stay and Continue Editing
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Leave Without Saving
      </Button>
    </DialogActions>
  </Dialog>
);

export default UnsavedChangesDialog;
